const ArticleListItem = () => import('../../components/article-list-item/index.vue');

export default {
    name: 'EmergencyEventsPage',
    
    components: {
        'list-item': ArticleListItem
    },

    computed: {
        list() {
            return this.$store.getters.getArticleList(10001);
        }
    },

    created() {
        this.$store.dispatch('fetchArticles');
        this.$store.dispatch('fetchMissingArticles');
        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Emergency Events', slug: 'emergency-events', back_url: '/action' });
    }
};